var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.stepNumber)?_c('div',{staticClass:"dot"},[_vm._v("\n    "+_vm._s(_vm.stepNumber)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"slot"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }